import React from "react";
import { ListGroup, Row, Col } from "react-bootstrap";
import { ILinkedWizardListItem } from "interfaces/Components/LinkedWizard/ILinkedWizardListItem";

interface ILinkedWizardListItemProps {
    item: ILinkedWizardListItem;
    onClick: (key : string) => void;
    onKeyDown: (e : React.KeyboardEvent<HTMLElement>) => void;
}

const LinkedWizardListItem = React.forwardRef(({ item, onClick, onKeyDown } : ILinkedWizardListItemProps, ref : any) => {
    
    const { key, icon, label, selected, disabled } = item;
    
    let cssClass = "";
    if (selected && !disabled) {
        cssClass = "bg-success border border-success";
    }
    if (selected && disabled) {
        cssClass = "bg-secondary border border-secondary";
    }

    let adjustedIcon : JSX.Element | undefined = undefined;
    if (icon) {
        adjustedIcon = React.cloneElement(icon, { size: 34 });
    }



    return <ListGroup.Item ref={ref} key={key} action onClick={() => { onClick(key) }} onKeyDown={(e) => onKeyDown(e)} active={selected} disabled={disabled} className={cssClass}>
        <Row>
            {adjustedIcon && <Col xs={"auto"}>
                {adjustedIcon}
            </Col>}
            <Col className="d-flex align-items-center">
                {label}
            </Col>
        </Row>
    </ListGroup.Item>
});

export { LinkedWizardListItem };